import firebase from "firebase/compat/app";
import "firebase/compat/firestore";
import "firebase/compat/storage";
import { logMessage } from "../utils/helpers";
import { firebaseConfig } from "../config/firebaseConfig";

// Initialize Firebase
firebase.initializeApp(firebaseConfig);

export const uploadImage = async (image, type) => {
  try {
    logMessage("goin here");
    const timestamp = Date.now();
    const imageName = `${timestamp}_${image.name}`;
    logMessage("goin here 2");
    let folder = "user_projects";
    // Adjust based on type
    if (type === "profile") {
      folder = "user_profile_images";
    } else if (type === "canvas") {
      folder = "user_canvas_images";
    } else if (type === "milestone") {
      folder = "milestone";
    }
    const storageRef = firebase.storage().ref().child(folder);
    logMessage("goin here 2.2");
    const imageRef = storageRef.child(imageName);
    logMessage("goin here 3");
    await imageRef.put(image);
    logMessage("goin here 4");
    const imageUrl = await imageRef.getDownloadURL();
    logMessage(imageUrl);
    return imageUrl;
  } catch (error) {
    return "";
  }
};

export const deleteImage = async (imageUrl) => {
  try {
    if (!imageUrl) return true;
    const storageRef = firebase.storage().refFromURL(imageUrl);
    await storageRef.delete();
    logMessage("Image deleted successfully");
    return true;
  } catch (error) {
    logMessage("Error deleting image: " + error.message);
    return false;
  }
};
